import { render, staticRenderFns } from "./IndexMaterialsPage.vue?vue&type=template&id=34b57b88&"
import script from "./IndexMaterialsPage.vue?vue&type=script&lang=js&"
export * from "./IndexMaterialsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports